import createLucideIcon from '../createLucideIcon';

const SeparatorVertical = createLucideIcon('SeparatorVertical', [
  ['line', { x1: '12', x2: '12', y1: '3', y2: '21', key: '1efggb' }],
  ['polyline', { points: '8 8 4 12 8 16', key: 'bnfmv4' }],
  ['polyline', { points: '16 16 20 12 16 8', key: 'u90052' }],
]);

export default SeparatorVertical;
